// Photo Gallery Masonry Layout - Edge Theme Style
(function () {
    'use strict';

    // Look for Edge-style post-feed (new) or legacy gh-photo-masonry
    const grid = document.querySelector('.post-feed') || document.querySelector('.gh-photo-masonry');
    if (!grid) return;

    // Check if Masonry library is loaded
    if (typeof Masonry === 'undefined' || typeof imagesLoaded === 'undefined') {
        console.error('Masonry or imagesLoaded library not loaded');
        // Fallback: show grid anyway
        grid.classList.add('initialized');
        return;
    }

    let masonry;

    // Determine which style we're using based on grid class
    const isEdgeStyle = grid.classList.contains('post-feed');

    // Wait for all images to load before initializing Masonry
    imagesLoaded(grid, function () {
        if (isEdgeStyle) {
            // Edge theme configuration - uses fixed-width columns
            masonry = new Masonry(grid, {
                itemSelector: '.grid-item',
                columnWidth: '.grid-sizer',
                hiddenStyle: { transform: 'translateY(50px)', opacity: 0 },
                visibleStyle: { transform: 'translateY(0)', opacity: 1 },
            });
        } else {
            // Legacy configuration - uses percentage-based responsive columns
            masonry = new Masonry(grid, {
                itemSelector: '.gh-photo-item',
                columnWidth: '.gh-photo-item',
                percentPosition: true,
                gutter: 16,
                hiddenStyle: { transform: 'translateY(50px)', opacity: 0 },
                visibleStyle: { transform: 'translateY(0)', opacity: 1 },
            });
        }

        // Mark grid as ready once layout is complete
        masonry.on('layoutComplete', function () {
            grid.classList.add('initialized');
        });

        masonry.layout();
    });

    // Initialize lightbox for Edge-style photo feed
    if (isEdgeStyle) {
        initPhotoFeedLightbox('.post-feed', '.post', '.post-lightbox-trigger', '.post-caption');
    }
})();

// Lightbox initialization for photo feed (Edge theme style)
function initPhotoFeedLightbox(container, element, trigger, caption) {
    'use strict';

    // Parse all photo items in the feed
    var parseThumbnailElements = function (el) {
        var items = [];
        var gridEl, linkEl, item;

        var photoElements = el.querySelectorAll(element);
        photoElements.forEach(function (v) {
            gridEl = v;
            linkEl = gridEl.querySelector(trigger);

            // Get the full-size image URL from the lightbox link
            item = {
                src: linkEl ? linkEl.getAttribute('href') : '',
                w: 0,
                h: 0,
            };

            // If there's a caption, include it in the lightbox
            var captionEl = gridEl.querySelector(caption);
            if (captionEl) {
                item.title = captionEl.innerHTML;
            }

            items.push(item);
        });

        return items;
    };

    // Open PhotoSwipe lightbox
    var openPhotoSwipe = function (index, galleryElement) {
        var pswpElement = document.querySelectorAll('.pswp')[0];
        if (!pswpElement) {
            console.error('PhotoSwipe element (.pswp) not found in DOM');
            return;
        }

        var items = parseThumbnailElements(galleryElement);

        var options = {
            closeOnScroll: false,
            history: false,
            index: index,
            shareEl: false,
            showAnimationDuration: 0,
            showHideOpacity: true,
        };

        // Initialize PhotoSwipe
        var gallery = new PhotoSwipe(
            pswpElement,
            PhotoSwipeUI_Default,
            items,
            options
        );

        // Get image dimensions after loading
        gallery.listen('gettingData', function (index, item) {
            if (item.w < 1 || item.h < 1) {
                var img = new Image();
                img.onload = function () {
                    item.w = this.width;
                    item.h = this.height;
                    gallery.updateSize(true);
                };
                img.src = item.src;
            }
        });

        gallery.init();
    };

    // Handle click on lightbox trigger button
    var onThumbnailsClick = function (e) {
        e.preventDefault();

        var targetElement = e.target.closest(element);
        var containerElement = e.target.closest(container);
        
        if (!targetElement || !containerElement) return false;

        var photoElements = containerElement.querySelectorAll(element);
        var index = Array.from(photoElements).indexOf(targetElement);

        openPhotoSwipe(index, containerElement);

        return false;
    };

    // Add click listeners to all lightbox triggers
    var containerEl = document.querySelector(container);
    if (containerEl) {
        containerEl.addEventListener('click', function (e) {
            if (e.target.closest(trigger)) {
                onThumbnailsClick(e);
            }
        });
    }
}



